import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

// Component creates a shadow root. It also copies our glboal css styles inside.
export function ShadowDomContainer({
  children,
  containerRef,
  ...props
}: {
  children: React.ReactNode;
  containerRef?: React.ForwardedRef<HTMLDivElement | null>;
} & React.HTMLProps<HTMLDivElement>) {
  const [shadowRoot, setShadowRoot] = useState<ShadowRoot | undefined>(undefined);

  return (
    <>
      <div
        ref={(el) => {
          if (typeof containerRef === "function") {
            containerRef(el);
          } else if (containerRef) {
            containerRef.current = el;
          }

          if (el?.shadowRoot === null) {
            el.attachShadow({ mode: "open" });
          }
          setShadowRoot(el?.shadowRoot ?? undefined);
        }}
        {...props}
      ></div>
      {shadowRoot &&
        createPortal(
          <>
            <div
              data-pyne-css="shadow-container"
              ref={(el) => {
                if (el && el.children.length === 0) {
                  const styles = document.querySelectorAll("head > [data-pyne-css=host]");
                  styles.forEach((style) => {
                    el.appendChild(style.cloneNode(true));
                  });
                }
              }}
            />
            {children}
          </>,
          shadowRoot
        )}
    </>
  );
}
